View = require 'app/scripts/views/internal/view'
t = require('app/scripts/views/internal/teacup-with-helpers')('create-first-team')
React = require 'react'
ReactDOM = require 'react-dom'
{ Moonshot } = require('app/src/components/Moonshot')
{ renderComponent } = require 'app/src/components/ComponentWrapper'

module.exports = class CreateFirstTeamView extends View
  tagName: 'div'
  className: 'create-first-team-wrapper'

  remove: ->
    ReactDOM.unmountComponentAtNode(@root)

  render: ->
    @$el.html(t.renderable => t.div '.js-create-first-team')
    @root = @$('.js-create-first-team')[0]

    renderComponent(
      React.createElement(Moonshot, {}),
      @root
    )

    @
